export default __webpack_public_path__ + "static/media/char_head_009.fb90467c.png";